module.exports = __webpack_public_path__ + "static/img/alias_contest.1ca3adc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contests/alias_contest.jpg
// module id = w0wA
// module chunks = 13